import { addDoc, doc, getDoc, collection, setDoc } from 'firebase/firestore';
import { db, functions } from './firebase';
import { httpsCallable } from 'firebase/functions';
import { getAuth } from 'firebase/auth';

export const createInvitation = async ({ companyId, companyName, email, role = 'member', inviterUid, expiresAt = null }) => {
  // Use callable Cloud Function to create the invitation (server-side) so Firestore rules won't block client
  const createInvFn = httpsCallable(functions, 'createInvitation');
  const res = await createInvFn({ companyId, companyName, email, role });
  return res.data && res.data.tokenId ? res.data.tokenId : null;
};

export const acceptInvitation = async (tokenId) => {
  // Use HTTP endpoint instead of callable to avoid CORS issues
  const auth = getAuth();
  const user = auth.currentUser;
  if (!user) throw new Error('User must be signed in to accept invitation');
  const token = await user.getIdToken();

  const url = 'https://us-central1-facturation-c415d.cloudfunctions.net/acceptInvitationHttp';
  const res = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify({ tokenId })
  });

  if (!res.ok) {
    const text = await res.text().catch(() => null);
    throw new Error(`acceptInvitation failed: ${res.status} ${text || ''}`);
  }

  const data = await res.json();
  return data;
};

export const createFirstCompany = async (userId, companyName) => {
  // Call the HTTP function `createCompanyHttp` directly (CORS-friendly)
  // We send the Firebase ID token in Authorization header so the function can verify identity.
  const auth = getAuth();
  const user = auth.currentUser;
  if (!user) throw new Error('User must be signed in to create a company');
  const token = await user.getIdToken();

  const url = 'https://us-central1-facturation-c415d.cloudfunctions.net/createCompanyHttp';
  const res = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify({ name: companyName })
  });

  if (!res.ok) {
    const text = await res.text().catch(() => null);
    throw new Error(`createCompanyHttp failed: ${res.status} ${text || ''}`);
  }

  const data = await res.json();
  return data && data.companyId ? data.companyId : null;
};

export const runMigration = async (appId = 'default') => {
  const migrateFn = httpsCallable(functions, 'migrateCompanyId');
  const res = await migrateFn({ appId });
  return res.data;
};
